import axiosIns from '@/libs/axios'

const STORAGE_USER_DATA_KEY = 'userData'

const state = {
  accessToken: null,
}

const getters = {
  getAccessToken: state => state.accessToken,
  isAuthenticated: state => !!state.accessToken,
}

const mutations = {
  SET_ACCESS_TOKEN(state, token) {
    state.accessToken = token
  },
  CLEAR_AUTH(state) {
    state.accessToken = null
  },
}

const actions = {
  login({ commit }, credentials) {
    return axiosIns.post('/auth/login', credentials).then(response => {
      if (response.statusCode === 200) {
        commit('SET_ACCESS_TOKEN', response.result.token)
        response.result.token = null;
        localStorage.setItem(STORAGE_USER_DATA_KEY, JSON.stringify(response.result))
      }
      return response
    })
  },

  refreshToken({ commit }) {
    return axiosIns.post('/auth/refresh-token').then(response => {
      const token = response.result?.token ?? response.result
      commit('SET_ACCESS_TOKEN', token)
      return token
    }).catch(error => {
      commit('CLEAR_AUTH')
      return Promise.reject(error)
    })
  },

  logout({ commit }) {
    return axiosIns.post('/auth/logout')
      .catch(() => {})
      .finally(() => {
        commit('CLEAR_AUTH')
        localStorage.removeItem(STORAGE_USER_DATA_KEY)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
